import { Link } from "react-router-dom";
import { Gavel } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-[#D9D4CC] bg-[#FDFBF7] mt-16">
      <div className="max-w-5xl mx-auto px-6 sm:px-8 py-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2.5">
            <Gavel className="w-5 h-5 text-[#2C2A29]" strokeWidth={1.75} />
            <span className="font-heading text-lg text-[#2C2A29]">It Is Established</span>
          </div>
          <nav className="flex items-center gap-6 text-sm text-[#4A4744]">
            <Link data-testid="footer-privacy" to="/privacy" className="hover:text-[#2C2A29] transition-colors duration-300">Privacy Policy</Link>
            <Link data-testid="footer-terms" to="/terms" className="hover:text-[#2C2A29] transition-colors duration-300">Terms &amp; Conditions</Link>
            <Link data-testid="footer-feedback" to="/feedback" className="hover:text-[#2C2A29] transition-colors duration-300">Feedback</Link>
          </nav>
        </div>
        <p className="text-center sm:text-left font-body text-xs text-[#7A756E] mt-8">
          © {new Date().getFullYear()} War-Zone Global Ministry. All rights reserved. Scripture decrees are drawn from publicly available Bible translations.
        </p>
      </div>
    </footer>
  );
}
